<div class="card-layout mb-3">
  <ng-content></ng-content>
</div>
